export const updateReports = [
        {
          ver : '0.16.24',
          reports : [
            '일반·익스프레스 상품 스캔 처리 중 추가 입력을 폐기하고 결과 반영 후 2초 동안 다음 스캔을 차단하며 HBL 확인은 기존 흐름 유지',
            '상품 확인·등록 중 후속 스캔 대기열을 없애고 처리 후 재스캔 안내 제공',
            '수량 저장 응답이 불명확하면 재스캔·수량 조정·완료를 차단하고 새로고침 후에도 관리자 확인 안내 유지'
          ]
        },
        {
          ver : '0.16.23',
          reports : [
            '오더 상세에서 관리자가 사유를 입력해 AONE 포장완료를 포장대기로 취소하는 기능 구현',
            '취소 사유와 이전 상태를 보존하고 포장·출력 확인 및 임시콘솔 대기를 함께 초기화',
            '콘솔 연결·진행 중인 출력·확인 이후 변경을 차단하고 응답 유실 시 같은 요청 결과 확인 지원',
            '취소 이전 작업의 늦은 완료·출력 요청을 차단하고 재선택 후 새 포장 회차로 진행'
          ]
        },
        {
          ver : '0.16.22',
          reports : [
            '익스프레스 자동선택은 주문 전체가 상품 한 행, 수량 1개인 주문만 대상으로 하며 나머지 주문은 변경 없이 일반 포장 대상으로 유지',
            '같은 바코드의 일반 포장 대상 주문을 건너뛰고 다음 익스프레스 주문을 선택하며, 대상이 없으면 상품 미등록 안내와 구분',
            '운송장 준비와 익스프레스 완료 저장에서 상품 구성을 다시 검사하고 일반 포장의 다품목·다수량 및 공용 출력을 유지'
          ]
        },
        {
          ver : '0.16.21',
          reports : [
            '포장 주체가 바뀐 주문은 선택·운송장 준비·출력·완료 저장 시 현재 주체를 다시 확인해 다른 주체의 작업을 차단',
            '여러 탭에서 진행 중인 출력 요청과 출력 전 해제 대기를 분리하고 다른 탭의 복구가 진행 중인 출력을 해제하지 않도록 보강',
            '외부 파트너 API에도 같은 출력 보호 규칙을 적용하고 파트너 전환 시 포장 작업과 이력을 보존'
          ]
        },
        {
          ver : '0.16.20',
          reports : [
            '통합조회에서 선택한 주문의 포장 주체를 AONE 또는 각 주문의 소유 파트너로 일괄 변경하는 관리자 기능 추가',
            '서로 다른 기존 주체가 섞인 선택도 처리하고 변경·동일·변경 불가 건수와 주문별 사유를 안내',
            '포장 진행·출력 접수 중인 건과 콘솔 등록 건을 보호하고 요청 재확인 및 변경 이력 보존 지원',
            '익스프레스 출력은 기존 출력 선점을 재사용하며 출력 전 실패는 안전하게 해제하고 결과 불명 시 재출력 차단 유지'
          ]
        },
        {
          ver : '0.16.19',
          reports : [
            '포장 주문 선택 전 주문이 없는 바코드의 미등록·기존 상품·파트너 연결 누락·비활성·가등록 상태를 구분해 일반·익스프레스에 안내',
            '미등록 안내는 입력 바코드 기준으로 제공하며 실제 등록은 풀필먼트 신규 등록에서 진행, 등록창·자동 이동·자동 저장 없음',
            '상품 조회 오류를 미등록으로 판단하지 않고 파트너 사용자에게는 자기 상품 연결 범위만 안내'
          ]
        },
        {
          ver : '0.16.18',
          reports : [
            '상품 등록·재개 대기 중 익스프레스 연속 스캔을 개별 보관하고 입력을 비워 바코드 합침을 방지',
            '등록 모달에 대기 스캔 입력란과 대기 건수를 추가하고 취소·실패 시 원래 주문과 대기열을 유지',
            '대기 스캔의 파트너·모드·조회 기간·작업자를 고정하여 다른 컨텍스트에서 자동 처리하지 않도록 보강',
            '상품 저장 잠금의 획득·정리 결과가 불명확한 DB 연결은 정상 풀로 반환하지 않도록 보강'
          ]
        },
        {
          ver : '0.16.17',
          reports : [
            '포장 중 미등록 상품은 확인 후 등록창을 열고 별도 저장하며, 기존 상품의 연결 누락과 필수정보 부족을 구분하여 처리',
            '새 포장 상품 복구 API에서 관리자 권한과 주문·파트너 범위를 검증하고 상품·연결을 함께 저장',
            '취소·조회 오류·저장 실패 시 주문과 수량을 유지하고 상품 확인 후 같은 주문의 중단 단계만 재개',
            '동시 등록과 응답 유실 후 저장 재시도를 보호하고, 출력 결과 불명확 시 자동 재출력 금지 유지'
          ]
        },
        {
          ver : '0.16.16',
          reports : [
            '익스프레스 실패 안내를 주문 조회·상품 기준·운송장 준비·출력 접수·결과 불명·완료 저장·이전 미해결 기록으로 구분',
            '상단 안내와 최근 스캔 로그에 같은 원인과 다음 행동을 표시하고, 내부 오류는 안전한 안내와 문의번호로 제공',
            '출력 접수와 실제 종이 출력을 구분하며 결과 불명 시 재출력을 차단하고 완료 저장 실패 시 저장 요청만 재시도'
          ]
        },
        {
          ver : '0.16.14',
          reports : [
            '포장 화면에 임시콘솔 + 포장완료 백업 버튼 추가: 오더·최종 중량 확인 후 수동 완료 및 임시콘솔 대기를 함께 저장',
            '수동 완료는 운송장 재출력 없이 출력 상태를 유지하며 처리 이력을 기록하고, 콘솔 연결·가등록 미확정 상품을 차단',
            '통합조회 서버 페이징 복구: 전체 조회 건수와 페이지 이동을 제공해 100건 이후 주문도 조회 가능',
            '페이지 이동 시 검색조건 유지, 페이지별 50·100·200건 선택 및 전체 결과 기준 정렬 지원',
            '조회 중 선택 초기화와 중복 요청 방지, 늦게 도착한 이전 응답이 최신 목록을 덮어쓰는 문제 방지'
          ]
        },
        {
          ver : '0.16.13',
          reports : [
            '이미 실제 콘솔에 연결된 주문은 일반·익스프레스 포장 자동선택과 수동조회에서 제외',
            '조회 후 콘솔에 연결된 주문의 포장 출력·진행·완료 요청도 서버에서 재검증해 차단'
          ]
        },
        {
          ver : '0.16.12',
          reports : [
            '익스프레스 가등록 상품의 스펙·중량 확정창 복구: 확정 후 같은 주문의 자동 출력과 포장완료를 이어서 처리',
            '가등록 상품 확인 중 다음 스캔은 순서대로 대기하며, 확인 취소·저장 실패 시 출력하지 않도록 보강'
          ]
        },
        {
          ver : '0.16.11',
          reports : [
            '개발 서버에서 화면 스타일이 적용되지 않는 문제 수정'
          ]
        },
        {
          ver : '0.16.10',
          reports : [
            '포장 익스프레스 출력 후 포장완료 저장 오류 수정',
            '출력 후 완료 요청 재시도에 성공하면 화면을 다음 상품 스캔 대기 상태로 자동 복구',
            '개발 서버 업데이트 후 이전 화면 코드가 남는 브라우저 캐시 문제 수정'
          ]
        },
        {
          ver : '0.16.9',
          reports : [
            '익스프레스 서버 배정 기능 제거: 상품 바코드로 미완료 주문을 조회하고 운송장 출력 후 포장완료하는 기본 흐름으로 정리',
            '익스프레스 완료 복구: 출력 접수 후 저장 실패 시 같은 브라우저에서 완료 요청만 재시도',
            '익스프레스 작업 안내: 서버의 다중 작업자 선점·만료·재시도 대기를 제거하고 출력 응답이 불명확한 상품은 관리자 확인 후 처리'
          ]
        },
        {
          ver : '0.16.8',
          reports : [
            '일반 포장 절차 강화: 최초 HBL, 주문 상품 전량, 최종 HBL, 실측 무게 순서가 완료된 경우에만 포장 완료 가능',
            '포장 작업 복원 추가: 포장 화면을 다시 열어도 최근 포장 시작 이후의 상품 스캔 수량과 진행 단계를 서버 이력에서 복원',
            '포장 완료 안정성 강화: 저장 무게와 풀필먼트 완료 상태를 하나의 트랜잭션으로 반영하고 운송장에는 서버에 저장된 무게만 출력'
          ]
        },
        {
          ver : '0.16.7',
          reports : [
            '파트너 오더 관리자 예외 입고 추가: 장애 또는 AONE 포장 불가 상황에서 포장주체와 관계없이 입고 처리할 수 있는 관리자 전용 토글 제공',
            '예외 입고 안전장치 추가: 위험 안내 확인 후에만 기능이 활성화되며 예외 사용 여부와 기존 포장주체를 포장 이력에 기록'
          ]
        },
        {
          ver : '0.16.6',
          reports : [
            '통합조회 목록 요약 개선: 조회·선택 건수와 진행·포장·콘솔 상태 단계 안내를 목록 상단에 표시',
            '통합조회 상세 접근성 개선: Order No. 버튼으로 상세 화면을 열고 행 내부 선택·배송조회 조작과 클릭 동작이 충돌하지 않도록 보강',
            '통합조회 운송장 출력 표시 개선: 출력 여부를 읽기 쉬운 배지와 접근성 설명으로 제공하고 모바일 요약 배치를 정리'
          ]
        },
        {
          ver : '0.16.5',
          reports : [
            '통합조회 상태 정보 가독성 개선: 진행상태, 포장주체, 포장상태, 콘솔상태, 배송조회를 연속 배치하고 상태별 배지로 구분',
            '통합조회 목록 표시 개선: 셀 경계선, 헤더 배경, 행 강조, 빈 결과 안내를 보강하고 포장상태 정렬 기준을 실제 상태값으로 정리'
          ]
        },
        {
          ver : '0.16.4',
          reports : [
            '통합조회 Description 표시 개선: 긴 상품 설명은 한 줄로 줄여 표시하고 마우스를 올리면 전체 내용을 확인할 수 있도록 변경',
            '통합조회 상세 조건 UI 개선: 주문 처리 상태, 콘솔 구분, 콘솔 상태, 포장 상태, 파트너 조건을 영역별로 정리하고 적용 조건 수와 일괄 초기화를 제공',
            '통합조회 포장완료 필터 추가: 포장완료된 주문만 빠르게 조회할 수 있도록 상세 검색 조건을 보강',
            '통합조회 콘솔 상태 표시 추가: 각 주문의 미등록, 연결대기, 연결완료 상태를 목록에서 배지로 바로 확인하도록 개선',
            '임시콘솔 등록 검증 강화: 포장완료 상태이고 아직 콘솔에 연결되지 않은 주문만 등록되도록 사전 검증하고 부적합 사유를 안내',
            '임시콘솔 등록 동시성 안정화: 등록 도중 주문 상태가 변경되면 전체 처리를 취소하고 목록을 새로고침하도록 트랜잭션 검증 보강',
            '통합조회 콘솔 상태 일관성 개선: 실제 콘솔에 연결된 주문은 임시 상태와 관계없이 연결완료로 표시하도록 보정',
            '구형 묶음화물 관리 기능 정리: 더 이상 사용하지 않는 묶음화물 화면과 API를 제거하고 현재 사용 중인 엑셀 오더 등록은 유지'
          ]
        },
        {
          ver : '0.16.3',
          reports : [
            '관리자 워크스페이스 상단 탐색 개선: 패키지 전환과 구분된 대시보드 바로가기 아이콘을 제공',
            '로그인 화면 통합: 고객, 파트너, 관리자가 같은 화면에서 로그인하고 계정 권한과 계약 서비스에 따라 알맞은 초기 화면으로 자동 이동하도록 개선',
            '로그인 화면 UI 개선: 모바일 대응 레이아웃, 입력 오류 안내, 비밀번호 표시, 로그인 진행 상태를 제공하도록 정리',
            '기존 파트너 로그인 주소 호환: /partnerAdmin 접근 시 통합 로그인 화면으로 자동 이동하도록 변경',
            '익스프레스 규칙 관리 추가: 관리자가 파트너·브랜드·카테고리별 포장 익스프레스 허용 범위를 등록·수정·비활성화할 수 있도록 지원',
            '회원가입 화면 개선: 로그인 화면과 일관된 반응형 UI, 항목별 검증, 약관 확인, 비밀번호 표시, 제출 진행 상태를 제공',
            '회원가입 검증 강화: 서버에서 이메일, 비밀번호, 이름, 휴대폰번호, 국가 및 필수 동의를 검증하고 중복 이메일을 명확하게 안내'
          ]
        },
        {
          ver : '0.16.2',
          reports : [
            '통합조회와 오더등록정보에 포장주체를 표시해 AONE 포장 대상과 파트너 포장 대상을 구분하도록 개선',
            '관리자 대시보드 통계 고도화: 오더생성 단계는 제외하고 오더접수 이력이 있는 화물만 주간·월간 통계에 반영',
            '관리자 대시보드 비교 통계 추가: 이번 주/이번 달 오더접수 및 수령완료 건수를 전주·전월 동기와 비교',
            '관리자 대시보드 지연 화물 표시 추가: 오더접수 후 30일 이상 수령완료되지 않은 화물을 현재 지연 건수로 표시',
            '관리자 대시보드 처리 목록 추가: 지연 화물, 주간·월간 접수·수령완료, 현재 상태, 일별 추이에서 동일 기준의 상세 목록으로 이동',
            '관리자 대시보드 상태 정체 경고 추가: 최근 상태 변경 후 7일 이상 수령완료되지 않은 화물과 처리 목록 제공',
            '관리자 대시보드 파트너별 운영 비교 추가: 주간·월간 접수/수령완료, 지연, 상태 정체 현황을 파트너별로 비교하고 상세 목록 이동 지원',
            '관리자 대시보드 처리 품질 지표 추가: 파트너별 주간·월간 완료율과 수령완료 주문 기준 평균 처리일을 비교',
            '관리자 대시보드 운영 경고 기준 설정 추가: 공통 및 파트너별 상태 정체·지연 기준일을 저장하고 대시보드 집계에 반영',
            '관리자 대시보드 최근 7일 오더접수 추이 개선: 오늘을 포함한 최근 7일을 표시하고 주문이 없는 날짜는 0건으로 보정하며 그래프 선과 포인트의 시인성을 강화',
          ]
        },
        {
          ver : '0.16.1',
          reports : [
            '우체국 배송조회 연동 추가: H/BL No. 우체국 등기번호 기준으로 우체국 종적조회 API 결과를 별도 배송조회 상태로 저장',
            '배송완료 자동 반영 추가: 우체국 응답이 배달완료일 때만 ORDER 상태를 배송완료 코드로 자동 변경하고 관리자 수동상태를 우선',
            '배송조회 배치 추가: 매일 새벽 3시 우체국 배송조회 대상 오더를 선별해 상태를 갱신',
            '통합조회 배송조회 UI 추가: 배송조회 상태 표시, 진행 내역 확인, 15분 제한 수동 재조회 지원'
          ]
        },
        {
          ver : '0.16.0',
          reports : [
            '포장완료 후 콘솔대기 DB 전환: 포장 완료 건을 브라우저 임시 목록이 아닌 PACKING_TASK 임시콘솔 상태로 저장하도록 변경',
            '임시콘솔 상태 관리 추가: temp_consol_status를 NONE, READY, LINKED로 관리하고 포장완료 시 READY, 실제 콘솔 연결 시 LINKED로 전환',
            '콘솔 해제 흐름 보강: 실제 콘솔에서 해제된 포장완료 건은 다시 임시콘솔 대기 상태로 복귀하도록 변경',
            '통합조회 임시콘솔상태 필터 추가: 없음, 콘솔대기, 연결완료 기준으로 오더를 조회할 수 있도록 검색 조건 보강',
            '임시콘솔목록 DB 조회 전환: 임시콘솔목록을 새로고침과 사용자 PC에 영향을 받지 않는 DB 기준 목록으로 조회하도록 변경',
            '임시콘솔목록 선택 해제 추가: 임시콘솔 대기 건 중 선택한 항목만 대기 상태에서 해제할 수 있도록 지원',
            '임시콘솔 팝업 UI 개선: 대기 오더 수, 선택 수, 파트너 수, 총 수량/중량 요약과 전용 컬럼을 제공하도록 정리',
            '콘솔 선택 팝업 UI 개선: 선택 오더 요약, 콘솔별 MBL, 편명/선명, 구간, 일정, 오더 수, 수량, 중량 정보를 확인 후 연결하도록 개선',
            '포장관리 파트너 경계 검증 강화: 동일 바코드가 여러 파트너에 존재해도 선택 파트너의 오더만 출력, 포장완료, 임시콘솔 처리되도록 서버와 화면 검증 보강',
            '포장관리 조회기간 프리셋 변경: 바코드 자동선택과 수동조회 기간 버튼을 최근 1달, 최근 2달 기준으로 단순화',
            '포장관리 스캔 확인 보강: 상품 바코드 성공 스캔 10회마다 스캔된 상품명을 확인한 뒤 다음 스캔을 진행하도록 변경',
            '포장관리 선택근거 표시 개선: 자동 선택된 상품명과 선택 기준, 상태 기준을 작업자가 읽기 쉬운 문장으로 표시',
            '포장관리 가등록 상품 확정 추가: 가등록 상품 바코드 스캔 시 현장 실측 스펙을 입력하고 확정등록으로 전환한 뒤 포장을 진행하도록 변경',
            '포장관리 익스프레스 모드 추가: 허용된 파트너와 상품 규칙에서는 상품 바코드 스캔만으로 운송장 출력 후 자동 포장완료 처리 지원',
            '포장관리 모드별 UI 구분 강화: 일반 모드와 익스프레스 모드의 배너, 단계 표시, 입력 영역을 분리해 현장 작업자가 현재 흐름을 명확히 구분하도록 개선',
            '포장관리 일반 모드 운송장 중복 출력 수정: 상품 바코드 최초 스캔에서만 자동 출력하고 HBL 1차 스캔은 포장 시작만 처리하도록 변경',
            '엑셀 업로드 실패 파일 다운로드 보안 강화: 업로드를 수행한 로그인 세션에서만 제한 시간 동안 실패 파일을 다운로드하도록 변경',
            '관리자 파일·스키마 기능 접근 제어 강화: 백업 파일, 업로드 파일, 스키마 스냅샷은 관리자 권한에서만 조회·다운로드하도록 변경',
            '파트너 API 보호 강화: 파트너 API에 호출 제한을 적용하고, 운영 설정에 따라 허용된 출발 IP만 접근하도록 지원',
            '물류 샘플 Bundle 처리 개선: 샘플 데이터의 날짜 형식을 일관되게 처리하고 Bundle JSON 파일 선택·해제 과정을 명확하게 개선',
            '풀필먼트 기본 물류값 분리: 중량, 부피, 가로/세로/높이를 규격 타입이 아닌 마스터 상품 기본값으로 관리하도록 변경',
            '풀필먼트 상품 옵션 규격 추가: 모델코드, 색상, 사이즈를 분리 관리하는 PRODUCT_OPTION 규격 타입 지원',
            '풀필먼트 UGG 상품 엑셀 등록 보강: AONE 표준 등록 양식에 모델코드, 색상, 사이즈, 바코드 정보를 입력해 일괄 등록 가능하도록 정리',
            '풀필먼트 바코드 기준 등록 보강: 동일 모델/색상/사이즈라도 바코드가 다르면 별도 마스터 상품으로 등록 가능하도록 조회와 검증 기준 조정',
            '통합조회 검색 개선: 관리자 배송상품조회에서 콘솔/비콘솔 화물을 기본적으로 함께 조회하고 필요 시 구분 필터를 선택하도록 변경',
            '풀필먼트 등록상태 조회 추가: 마스터 SKU 목록과 상세 화면에서 가등록/확정등록 상태 확인 및 필터링 지원',
            '파트너 API 오더 등록 안정화: 주문 등록 요청 timeout과 DB query timeout을 적용하고 timeout, DB 경합, DB 실패 오류 코드를 표준화',
            '풀필먼트 상품 바코드 관리 추가: 마스터 상품 기본정보에 바코드번호를 저장하고 목록, 상세, 승인, 매핑 화면에서 조회 지원',
            '풀필먼트 관리자 신규 등록 보강: 단건 신규 등록 시 바코드번호를 입력하면 마스터 SKU를 자동 제안하고 필요 시 직접 수정 가능',
            '풀필먼트 파트너 SKU 연결 보강: 관리자 신규 등록에서 파트너 연결 정보는 선택 입력으로 유지하고, 입력 시 기준 상품 생성과 동시에 연결',
            '풀필먼트 마스터 SKU 자동 코드 개선: 신규 마스터 SKU를 브랜드/카테고리 코드와 바코드 또는 순번 조합으로 생성하도록 변경',
            '풀필먼트 바코드 중복 방지: 마스터 상품 바코드는 전역 중복을 막고, 파트너 SKU는 같은 파트너 안에서 중복 등록되지 않도록 서버 검증 추가',
            '풀필먼트 상품 검색 보강: 파트너 상품, 승인 요청, 매핑 현황, 마스터 SKU 목록에서 바코드 검색 지원',
            '오더 상품명 입력 보강: 오더 수동 등록과 통합조회 상품 수정에서 상품명 괄호 입력 허용',
            '오더 엑셀 등록 바코드 매핑 추가: 엑셀 상품코드 컬럼 값을 상품 바코드로 저장하도록 변경',
          ]
        },
        {
          ver : '0.15.4',
          reports : [
            '고객 배송조회 보안 강화: H/BL 번호와 수취인 전화번호 뒷자리 4자리로 조회하도록 변경하고 공개 응답 개인정보를 최소화',
            '고객 배송조회 페이지 임시 제한: 검증 기간 동안 LOCAL 환경에서만 배송조회 페이지와 진입 버튼을 노출',
            '고객 배송조회 API 임시 제한: 백엔드 LOCAL 환경에서만 공개 조회 API가 응답하도록 제한',
          ]
        },
        {
          ver : '0.15.3',
          reports : [
            '파트너 API 오더 등록 상태 보정: API로 등록된 오더는 파트너가 출력 책임을 가진 것으로 보고 등록 즉시 출력됨 상태로 처리',
          ]
        },
        {
          ver : '0.15.2',
          reports : [
            '파트너 API 우편번호/화물집하코드 조회 추가: 외부 파트너가 API Key 인증으로 운송장 출력용 집하코드 정보를 조회할 수 있도록 제공',
            '파트너 API Key 기본 권한 보강: 신규 발급 기본 scope에 orders:create와 postcode:lookup을 함께 제안하도록 수정',
            '파트너 API Key 권한 수정 추가: 기존 API Key를 재발급하지 않고 scope만 업데이트할 수 있도록 관리 기능 추가',
          ]
        },
        {
          ver : '0.15.1',
          reports : [
            '오더 등록 운영 알림 보강: 일반 오더 등록 성공/실패와 파트너 API 등록 시도 알림에 파트너명을 표시하고 통합조회 바로가기를 제공',
            '파트너 계정 오더 등록 알림 수정: 파트너 화면에서 ORDER 등록 시 세션의 파트너 정보가 등록 컴포넌트에 전달되도록 보강',
          ]
        },
        {
          ver : '0.15.0',
          reports : [
            '관리자 전역 운영 알림 센터 추가: SSE 기반 운영 이벤트를 관리자 레이아웃에서 전역 수신하고 Quasar Notify로 즉시 표시',
            '상단 알림 버튼 추가: 관리자 헤더의 ORDER 등록 버튼 우측에 독립 알림 버튼과 미확인 알림 배지 표시',
            '우측 알림 패널 추가: 왼쪽 메뉴처럼 본문 영역을 밀어내는 방식으로 최근 알림 목록, 전체 읽음, 새로고침, 개별 읽음, 바로가기 지원',
            '운영 알림 API 호출 분리: 알림 목록 갱신은 대시보드 전체 조회와 분리하고 백그라운드 갱신 시 전역 스피너를 띄우지 않도록 처리',
            'BIZ 라우트 1차 정리: 기존 비즈니스 소개 화면을 /biz 경로에서도 접근 가능하게 하고 상단 메뉴와 홈 주요 링크를 BIZ 경로 기준으로 정리',
          ]
        },
        {
          ver : '0.14.0',
          reports : [
            '파트너 삭제 API 안정화: 프론트엔드 DELETE 호출과 백엔드 라우트 방식을 맞춰 파트너 삭제 404 오류 수정',
            '파트너 관리 화면 개선: 파트너 요약 카드, 계약 서비스/계약 상태 필터, 통합 검색, 등록·수정·삭제 후 목록 자동 갱신 지원',
            '파트너 정보 모달 1차 개선: 상단 요약 헤더, 기본정보·계약정보·담당자·API 연동 탭 분리, 삭제 작업 위험 영역 분리 적용',
            '고객 배송요청/조회 화면 개선: 고객용 제출 문구 정리, 단계별 안내 카드, 접수 완료 안내, 배송조회 검색 전 안내와 상태 배지 추가'
          ]
        },
        {
          ver : '0.13.0',
          reports : [
            '오더 등록 HS CODE 자동입력 1차 적용: Fulfillment 등록 상품과 HS CODE 매핑 기준을 조회해 상품명 입력 시 HS CODE 자동 반영',
            'HS CODE 매핑 기준 DB 추가: 정확히 일치, 키워드 포함, 우선순위, 활성 여부 기준으로 자동입력 규칙 관리',
            'HS CODE 관리 페이지 추가: 관리자 화면에서 매칭 기준 목록 조회, 등록, 수정, 비활성화, 상품명 매칭 테스트 지원',
            'HS CODE 관리 내장 가이드 추가: 매칭방식, 우선순위, 테스트 방법과 통관 정보 관리 주의사항 안내',
            'HS CODE 매칭 테스트 유사어 추천 추가: 자동 매칭 실패 시 기존 활성 매핑값 중 비슷한 단어를 추천하고 해당 기준으로 재테스트 지원'
          ]
        },
        {
          ver : '0.12.0',
          reports : [
            '파트너 외부 API 인증 기반 추가: 외부 파트너 연동을 위한 API Key 테이블, 해시 저장, 인증 미들웨어, 인증 확인 API 구성',
            '파트너사 정보관리 API Key 관리 추가: 관리자 정보관리 팝업에서 외부 연동 키 목록 조회, 발급, 1회 원문 복사, 비활성화 지원',
            '파트너 API 연동 가이드 추가: 관리자용 API 연동 도움말 팝업과 파트너 개발자 전달용 Markdown 스펙 문서 다운로드 제공',
            '파트너 외부 오더 등록 API 추가: API Key 인증 기반으로 파트너 주문 등록, 필수값 검증, 파트너별 외부 주문번호 중복 차단 지원'
          ]
        },
        {
          ver : '0.11.0',
          reports : [
            'FULFILLMENT 상품 관리 메뉴 개편: 상품 운영 현황, 요청/매핑 관리, 목록 조회, 신규 등록, 브랜드/카테고리 관리 구조로 정리',
            '상품 운영 현황 UI 개선: 상태 요약 카드, 전체 요청 대기 목록, 연결 검토 목록, 장기 미처리 요청, 최근 반려 목록 제공',
            '상품 운영 현황 바로가기 개선: 정상 연결 및 미연결 상품 카드에서 해당 필터가 적용된 목록으로 이동',
            '요청/매핑 관리 UI 개선: 요청 탭과 매핑 탭을 구분하고 요청 대기, 반려, 연결 검토, 정상 연결 상태별 조회 제공',
            '요청 상세 처리 UI 개선: 연결요청과 신규등록요청을 구분하고 권장 처리, 예외 처리, 반려 처리를 분리',
            '목록 조회 UI 개선: 검색 중심 화면, 연결 상태 빠른 필터, 상세 조건, 적용 조건 표시, 초기화, 조회 건수, 상세보기 액션 추가',
            '상품 상세 UI 개선: 기본 정보 수정, 연결된 파트너 SKU 확인 및 연결 해제, 관련 요청 바로 연결 승인 기능 제공',
            '관리자 신규 등록 기능 추가: 단건 등록과 엑셀 일괄 등록을 지원하고 엑셀 미리보기, 직접 수정, 재검증, 저장 흐름 적용',
            '브랜드/카테고리 관리 UI 통합: 탭 전환 방식으로 브랜드와 카테고리를 관리하고 등록, 수정, 활성 상태 변경 지원',
            '상품관리 내장형 사용 가이드 추가: 관리자 주요 메뉴와 상세 화면, 파트너 내 상품 현황, 내 상품목록 관리, 내 상품 상세, SKU 요청 생성 화면에서 도움말 아이콘 기반 가이드 팝업 제공',
            '파트너 상품관리 UI 개선: 내 상품 현황과 내 상품목록 관리 역할을 분리하고 브랜드, 카테고리, 상태 검색 필터 제공',
            '파트너 내 상품 현황 개편: 취급 상품 지표와 브랜드·카테고리 분포를 주영역으로 배치하고 등록·연결 요청 현황을 보조영역으로 분리',
            '파트너 상품 요청 등록 팝업 개선: 화면 내부 버튼으로 팝업을 열 때 현재 경로를 유지하고 직접 URL 접근 시에만 목록으로 복귀',
            '파트너 내 상품 상세 추가: 목록 행 또는 상세보기 아이콘에서 내 SKU의 기준 상품 정보, 규격, 처리 상태, 반려 사유 확인 지원',
            '콘솔 관리 안정화 및 UI 개선: 관리자 권한 강제, 안전한 검색 조건 처리, 콘솔·오더 상태 트랜잭션 적용, 운영 요약 카드와 상태 배지 제공',
            '포장 자동 출력 테스트 개선: 로컬 프린트 에이전트를 기본 출력 경로로 사용해 상품 바코드 스캔 후 운송장 즉시 출력 요청',
            '오더관리 운송장 미리보기 개선: PDF 다운로드와 별도로 로컬 에이전트 즉시 출력 버튼을 추가해 프린터 연동 테스트 지원',
            '로컬 프린트 에이전트 연동 개선: HTML 출력 대신 웹솔루션에서 생성한 운송장 PDF를 에이전트로 전달하는 방식으로 전환',
            '로컬 프린트 에이전트 1차 검증 완료: Windows 무설치 실행파일과 포터블 SumatraPDF 조합으로 테스트 출력 및 오더관리 운송장 PDF 출력 성공',
            '관리자 상단 버전 배지 개선: 환경변수 대신 업데이트 리포트 최신 버전을 기준으로 표시',
            '포장관리 자동 출력 연결: 상품 바코드 스캔 후 오더관리 운송장 출력 양식 기준의 PDF를 로컬 중계프로그램으로 즉시 전송하고 수동 재출력도 동일 경로로 처리',
            '운송장 출력 렌더러 공통화: 오더관리 미리보기와 포장 자동출력이 동일한 운송장 컴포넌트와 PDF 생성 함수를 사용하도록 정리',
            '포장 스캔 안내 개선: 대기 중인 상품이 없을 때는 스캔 실패 대신 안내 메시지를 표시하도록 수정',
            '포장 수동 운송장 출력 확인 추가: 출력 버튼 클릭 시 확인 팝업을 띄우고 사용자 승인 후에만 강제 출력하도록 변경',
            '상품관리 상태 용어 통일: 요청 대기, 연결 검토, 정상 연결, 부분 연결, 미연결, 반려, 활성, 비활성 표현 정리',
            '오더관리 실무게 수정 오류 수정: 상품 단가 0원 검증, 부피무게/실무게 필드 혼선, 서버 무게 검증 누락 및 중복 업데이트 처리 정리'
          ]
        },
        {
          ver : '0.10.2',
          reports : [
            'FULFILLMENT 상품 관리 고도화: SKU 관리 메뉴를 상품 관리 관점으로 재구성',
            '상품 목록/상품 상세 개편: 마스터 SKU를 상품 기준 정보로 보고 파트너 SKU 연결 현황을 함께 표시',
            '상품 운영 구조 정리: 승인 대기, 연결 처리 현황, 운영 현황 화면 신설',
            'FULFILLMENT 운영 현황 보드 추가: 승인 대기 건수, 연결 처리 필요 건수, 정상 연결/미연결 상품 수 및 처리 큐 제공',
            '상품 운영 IA 개선: 공통 대시보드와 별도로 FULFILLMENT 운영 현황 진입점 구성',
            '승인 대기 화면 개선: 요청 상품 정보, 기존 상품 후보, 처리 액션 중심으로 재구성',
            '연결 처리 현황 화면 개선: 상품 목록과 분리된 관계 처리 화면으로 재정의',
            '백엔드 집계/API 보강: partner_sku_count, mapping_status, partner_skus, relation_source, request_id 기반 응답 추가',
            '메인 DB(aone)와 fulfillment DB 분리 구조 반영: PARTNER 조인을 메인 DB 기준으로 수정'
          ]
        },
        {
          ver : '0.10.1',
          reports : [
            '화물번호 대역폭관리 기능 고도화: round 기반 탐색에서 다음 연결 대역(next_sequence_id) 기반 체인 구조로 전환',
            '시퀀스 현재 활성 대역 포인터(SEQUENCE_GROUP_STATE) 도입 및 대역 전환 시 자동 포인터 갱신 구조 반영',
            '화물번호 채번 프로시저(get_next_order_number) 개선: 현재 대역 소진 시 연결된 다음 대역 시작번호로 전환되도록 변경',
            '시퀀스 관리 백엔드 계약 개편: id, next_sequence_id, is_active, is_current, current_sequence_id 기준으로 저장/조회/비활성화 처리',
            '시퀀스 관리 화면 개선: 현재 대역 설정, 다음 대역 연결, 비활성화, 수정 기능 추가'
          ]
        },
        {
          ver : '0.10.0',
          reports : [
            '풀필먼트 포장 기능 본격 반영(프로토타입 → 운영 기능 전환)',
            '포장 화면 자동선택/수동조회 로직 정비 및 manualLookup 쿼리 이슈 수정',
            '포장 권한 정책 반영: 풀필먼트 계약 파트너만 포장업무 메뉴/기능 접근 가능',
            '사이드바 메뉴 노출 정책 개선: 파트너 계약(logis/fulfillment) 기준으로 메뉴 분기',
            '파트너 계약 관리 기능 추가: 파트너 등록/수정 화면에서 로지스틱스/풀필먼트 계약 설정 가능',
            '비밀번호 재설정 방식 변경: 이메일 발송 방식에서 관리자 링크 생성/복사 전달 방식으로 전환',
            '관리자 비밀번호 재설정 링크 생성 API 추가 및 30분 만료/1회성 토큰 정책 적용',
            '비밀번호 재설정 링크 팝업 UI 개선: 긴 URL이 화면을 벗어나지 않도록 모달 크기/줄바꿈/스크롤 처리 및 Copy to clipboard 버튼 추가',
            '로그 이력 확장: 비밀번호 재설정 링크 생성 성공/실패 이벤트(auth.password_reset_link_create*) 기록',
            '로그인 이력 관리/유저 행동 추적 화면에 신규 이벤트 필터 추가',
            '메일 발송 경로 및 nodemailer 의존성 제거'
          ]
        },
        {
          ver : '0.9.27',
          reports : [
            '콘솔 엑셀 다운로드 시 파트너 별 그룹핑 기능 추가',
          ]
        },
        {
          ver : '0.9.26',
          reports : [
            '유저 행동 추적 기능 추가'
          ]
        },
        {
          ver : '0.9.25',
          reports : [
            'PDF 변환 시 QR 코드 추가',
            '콘솔 다운로드시 - HS CODE 엑셀 다운로드시 편의기능 추가',
            '콘솔 다운로드시 - 오더번호에 파트너사 구분을 위한 접두사 추가',
          ]
        },
        {
          ver : '0.9.24',
          reports : [
            '로그인 이력조회 기능 추가',
          ]
        },
        {
          ver : '0.9.23',
          reports : [
            '통합조회 - 파트너사 별 조회 필터 추가',
            '대쉬보드 및 사이드바 디자인 수정'
          ]
        },
        {
          ver : '0.9.22',
          reports : [
            '파트너사 정보 직접 확인 및 수정 기능 추가',
          ]
        },
        {
          ver : '0.9.21',
          reports : [
            '긴급 배포 : 파트너사 조회시 콘솔된 오더도 조회되도록 수정',
          ]
        },
        {
          ver : '0.9.20',
          reports : [
            '엑셀 업로드 시 데이터를 미리보기로 확인할 수 있는 기능 추가',
            '엑셀 업로드 시 미리보기에서 데이터 수정이 가능한 기능 추가',
            '엑셀 업로드 시 미리보기에서 오류 데이터만 필터링하여 볼 수 있는 기능 추가',
          ]
        },
        {
          ver : '0.9.19',
          reports : [
            '오더가 콘솔이 된 경우. 상태를 "출발지-반출" 로 변경',
            '콘솔 상태 변경을 수정 창이 아닌 목록에서 변경할 수 있도록 수정',
          ]
        },
        {
          ver : '0.9.18',
          reports : [
            '오더 삭제 이후 선택된 목록을 초기화 하도록 수정',
            '삭제된 상품 관리에 콘솔 해제 기능 추가',
          ]
        },
        {
          ver : '0.9.17',
          reports : [
            '대쉬보드에 리프레시 버튼 생성',
            '화물대역폭관리 - 타입과 회차에 대한 정의 변경',
            '콘솔관리에서 엑셀 다운로드 시 파트너별 분리',
          ]
        },
        {
          ver : '0.9.16',
          reports : [
            '콘솔에 있는 오더 삭제 시 콘솔 해제',
          ]
        },
        {
          ver : '0.9.15',
          reports : [
            '고객 오더 수정시 접수자 Validation 강화',
            'PDF 가시성 보완',
            '삭제 아이템 관리 - 관리자 레벨 노출'
          ]
        },
        {
          ver : '0.9.14',
          reports : [
            '고객오더 입력 시 Validation 보완 - 수취인 연락처 필수 입력'
          ]
        },
        {
          ver : '0.9.13',
          reports : [
            '통합조회 시 출력여부 컬럼 추가',
            '오더상세 아이템목록에 주요컬럼 제외 숨김처리'
          ]
        },
        {
          ver : '0.9.12',
          reports : [
            '영문, 한글 입력 가이드 추가',
            'https:// 자동 입력 제거',
          ]
        },
        {
          ver : '0.9.11',
          reports : [
            '대시보드 - 1주일간 오더 상태별 현황으로 변경',
            '대시보드 - 조회기능을 단순화',
          ]
        },
        {
          ver : '0.9.10',
          reports : [
            '고객 오더 상품 조회 기능 개선 - 송장번호 또는 HBL번호로 조회 가능하도록 수정',
          ]
        },
        {
          ver : '0.9.9',
          reports : [
            '오더추가 UI 개선',
            '오더추가 시 관리자와 고객의 화면을 구분하여 처리',
            '오더추가 시 약관추가',
          ]
        },
        {
          ver : '0.9.8',
          reports : [
            '운송장 pdf 변환 시 페이지 하단에 생성시점 표기 추가',
            '홈페이지 항목에 빈값이 있을 경우 유효성 검사 통과하도록 수정'
          ]
        },
        {
          ver : '0.9.7',
          reports : [
            'G1 업로드양식으로 엑셀 컬럼오류추가',
            '세션의 오류 수정'
          ]
        },
        {
          ver : '0.9.6',
          reports : [
            'G1 업로드양식으로 엑셀 다운로드 기능 추가(콘솔관리 화면)',
            '파트너 로그인 화면 추가',
            '통합조회시 최대 1page에서 500건까지 조회 가능하도록 변경',
          ]
        },
        {
          ver : '0.9.5',
          reports : [
            '오더 등록시 전자상거래 유형 코드 추가',
            '오더 등록시 입력한 사이즈값이 아이템으로 잘못 입력되는 문제 수정'
          ]
        },
        {
          ver : '0.9.4',
          reports : [
            '운송장 pdf 변환 시 위치 최적화 및 우편물 분류를 위해 지정된 “행낭(행선지별 운송 자루)” 코드 적용',
            '관리자 로그인(최초진입 시) 통합조회 화면에서 기본으로 검색이 되지 않고 이동하도록 변경',
            '엑셀업로드 시 성공한 건수와 실패한 건수를 보여주도록 변경',
            '콘솔이 추가된 경우 스케쥴러 페이지에 일정을 표기',
          ]
        },
        {
          ver : '0.9.3',
          reports : [
            'ORDER등록 - 상품(Item) 등록 형식을 table에서 form으로 변경',
            '콘솔관리 - 콘솔 검색기능 추가',
            '모바일에서 접근 시 왼쪽 메뉴 숨김을 default으로 설정',
            '모바일에서 접근 시 상단 메뉴에서 텍스트 숨김을 default으로 설정',
            '모바일에서 입력창 포커스 시 화면 확대 방지',
          ]
        },
        {
          ver : '0.9.2',
          reports : [
            'ORDER등록 - Order number 자동 채번 기능 추가',
            '통합조회 - Consol 시 [출항 대기] 상태만 조회',
            '공통 - QR 등록 시 AONE 파트너 ID 자동 입력',
          ]
        },
        {
          ver : '0.9.1',
          reports : [
            '고객 비밀번호 변경 기능 추가',
          ]
        },
        {
          ver : '0.9.0',
          reports : [
            '통합조회',
            '콘솔관리',
            '운송편 관리',
            '화물 대역폭 관리',
            '파트너 기능 개선 - 파트너가 등록한 배송상품을 조회할 수 있는 기능 추가',
            '파트너 기능 개선 - QR로 고객 오더 등록화면 진입 및 등록'
          ]
        },
        {
          ver : '0.8.2',
          reports : [
            '데일리 백업파일 다운로드 기능 추가'
          ]
        },
        {
          ver : '0.8.1',
          reports : [
            '엑셀 업로드 기능 보완 및 새로운 모달로 분리',
            '배송상품조회 목록에서 row 선택시 모달을 띄우는 형식으로 변경. 수정 버튼 삭제됨.'
          ]
        },
        {
          ver : '0.8.0',
          reports : [
            '파트너 기능 추가 - 고객의 계정을 파트너로 등급업이 가능하며 파트너는 관리자 화면에 접근이 가능하지만 파트너 본인이 등록한 상품만 볼 수 있음',
            '파트너 로그인',
            '파트너 배송상품 등록'
          ]
        },
        {
          ver : '0.7.3',
          reports : [
            '픽업지 추가시 폼 코드영역 셀렉트 리스트로 변경',
            '배송등록 폼 디자인 보완'
          ]
        },
        {
          ver : '0.7.2',
          reports : [
            '코드관리에 부모코드 컬럼 생성'
          ]
        },
        {
          ver : '0.7.1',
          reports : [
            '브라우져 탭에 페이지 명 각 페이지별 적용',
            '페이지 이동시 스크롤을 항상 페이지 상단으로 이동'
          ]
        },
        {
          ver : '0.7.0',
          reports : [
            '코드관리 기능 추가'
          ]
        },
        {
          ver : '0.6.0',
          reports : [
            '업데이트 리포트 메뉴 생성'
          ]
        },
        {
          ver : '0.5.9',
          reports : [
            '배송상품조회 최초 진입시 날짜설정 오류 수정',
            '소통관리 공지사항 기능 강화'
          ]
        }
      ]

export const latestUpdateVersion = updateReports[0]?.ver || ''
